export function anonymousHallRow<T extends {
  anonymous?: boolean | null;
  user_id?: string | null;
  name?: string | null;
  avatar_url?: string | null;
}>(row: T): T & { user_id: string | null; name: string | null; avatar_url: string | null } {
  if (row.anonymous) {
    return {
      ...row,
      user_id: null,
      name: null,
      avatar_url: null,
    };
  }

  return {
    ...row,
    user_id: row.user_id ?? null,
    name: row.name ?? null,
    avatar_url: row.avatar_url ?? null,
  };
}
